var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgChevronCircle = function SvgChevronCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 49"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24,
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.47 24l-9.15-9.4a1.31 1.31 0 00-1.85 0 1.39 1.39 0 000 1.9l8.24 8.5-8.24 8.48a1.4 1.4 0 000 1.91 1.31 1.31 0 001.85 0l9.15-9.45a1.4 1.4 0 000-1.94z",
    fill: "currentColor"
  })));
};

export default SvgChevronCircle;